const L = "marzipan.images";
function w(r, d) {
  const u = r.textarea, v = u.selectionStart ?? 0, h = u.selectionEnd ?? 0;
  u.setRangeText(d, v, h, "end"), r.updatePreview(), u.focus();
}
function R() {
  try {
    return JSON.parse(localStorage.getItem(L) || "[]");
  } catch {
    return [];
  }
}
function y(r) {
  try {
    localStorage.setItem(L, JSON.stringify(r.slice(0, 50)));
  } catch {
  }
}
async function D(r) {
  const d = new FileReader();
  return new Promise((u, v) => {
    d.onerror = () => v(d.error), d.onload = () => u(String(d.result)), d.readAsDataURL(r);
  });
}
function A(r) {
  const d = r?.label ?? "🗂️", u = r?.title ?? "Images", v = Math.max(1, r?.maxRecent ?? 24), h = r?.persistThresholdBytes ?? 1 * 1024 * 1024;
  return (p) => {
    const k = p.container.querySelector(".marzipan-toolbar") ?? p.container, f = document.createElement("button");
    f.type = "button", f.className = "mz-btn mz-btn-imagemgr", f.title = u, f.textContent = d;
    let n = null, l = R();
    function g() {
      n?.remove(), n = null, document.removeEventListener("click", E, !0), window.removeEventListener("resize", g), window.removeEventListener("scroll", g, !0);
    }
    function E(e) {
      n && (e.target instanceof Node && (n.contains(e.target) || f.contains(e.target)) || g());
    }
    function z(e) {
      const t = e.querySelector(".mz-im-grid");
      t.innerHTML = "", l.slice(0, v).forEach((i, c) => {
        const s = document.createElement("div");
        s.className = "mz-im-card";
        const b = document.createElement("img");
        b.decoding = "async", b.loading = "lazy", b.src = i.url, b.alt = i.name;
        const m = document.createElement("div");
        m.className = "mz-im-actions";
        const a = document.createElement("button");
        a.type = "button", a.textContent = "Insert", a.onclick = () => {
          const I = r?.onInsert ? r.onInsert(i.url) : i.url;
          w(p, `![${i.name}](${I})`), g();
        };
        const o = document.createElement("button");
        o.type = "button", o.textContent = "✕", o.title = "Remove from recents", o.onclick = () => {
          l.splice(c, 1), y(l), z(e);
        }, m.append(a, o), s.append(b, m), t.appendChild(s);
      });
    }
    async function x(e) {
      try {
        let t;
        r?.uploader ? t = await r.uploader(e) : e.size <= h ? t = await D(e) : t = URL.createObjectURL(e), l = [{ url: t, name: e.name, createdAt: Date.now(), persistent: !t.startsWith("blob:") }, ...l.filter((s) => s.url !== t)], y(l), n && z(n);
        const c = r?.onInsert ? r.onInsert(t) : t;
        w(p, `![${e.name}](${c})`);
      } catch (t) {
        console.error("Image add failed:", t), alert("Could not add image.");
      }
    }
    async function S(e, t = "image") {
      l = [{ url: e, name: t, createdAt: Date.now(), persistent: !0 }, ...l.filter((s) => s.url !== e)], y(l), n && z(n);
      const c = r?.onInsert ? r.onInsert(e) : e;
      w(p, `![${t}](${c})`);
    }
    function C() {
      if (n) {
        g();
        return;
      }
      n = document.createElement("div"), n.className = "mz-pop mz-im-panel", n.innerHTML = `
        <div class="mz-im-row">
          <input class="mz-im-url" type="url" placeholder="https://example.com/image.png" />
          <button class="mz-im-addurl" type="button">Add URL</button>
          <input class="mz-im-file" type="file" accept="image/*" hidden />
          <button class="mz-im-upload" type="button">Upload</button>
          <button class="mz-im-clear" type="button" title="Clear recents">Clear</button>
        </div>
        <div class="mz-im-drop">Drop images here, or paste into the editor.</div>
        <div class="mz-im-grid"></div>
      `, document.body.appendChild(n);
      const e = f.getBoundingClientRect();
      n.style.left = `${Math.round(window.scrollX + e.left)}px`, n.style.top = `${Math.round(window.scrollY + e.bottom + 6)}px`;
      const t = n.querySelector(".mz-im-url"), i = n.querySelector(".mz-im-addurl"), c = n.querySelector(".mz-im-file"), s = n.querySelector(".mz-im-upload"), b = n.querySelector(".mz-im-clear"), m = n.querySelector(".mz-im-drop");
      i.onclick = () => {
        const a = t.value.trim();
        a && (S(a), t.value = "");
      }, s.onclick = () => c.click(), c.onchange = () => {
        const a = c.files?.[0];
        a && x(a);
      }, b.onclick = () => {
        confirm("Clear recent images?") && (l = [], y(l), z(n));
      }, ["dragenter", "dragover"].forEach(
        (a) => m.addEventListener(a, (o) => {
          o.preventDefault(), m.classList.add("on");
        })
      ), ["dragleave", "drop"].forEach(
        (a) => m.addEventListener(a, (o) => {
          o.preventDefault(), m.classList.remove("on");
        })
      ), m.addEventListener("drop", (a) => {
        const o = a.dataTransfer?.files;
        !o || !o.length || Array.from(o).forEach(x);
      }), z(n), setTimeout(() => {
        document.addEventListener("click", E, !0), window.addEventListener("resize", g), window.addEventListener("scroll", g, !0);
      }, 0);
    }
    p.textarea.addEventListener("paste", (e) => {
      const t = e.clipboardData?.items && Array.from(e.clipboardData.items).find((c) => c.kind === "file" && c.type.startsWith("image/"));
      if (!t) return;
      const i = t.getAsFile();
      i && (e.preventDefault(), x(i));
    }), p.container.addEventListener("dragover", (e) => {
      Array.from(e.dataTransfer?.items || []).some((t) => t.kind === "file") && e.preventDefault();
    }), p.container.addEventListener("drop", (e) => {
      const t = e.dataTransfer?.files;
      !t || !t.length || (e.preventDefault(), Array.from(t).forEach(x));
    }), f.onclick = C, k.appendChild(f);
  };
}
const U = `
.mz-im-panel { width: 440px; max-width: calc(100vw - 24px); }
.mz-im-row { display: grid; grid-template-columns: 1fr auto auto auto; gap: 6px; margin-bottom: 8px; }
.mz-im-row input[type="url"] {
  background: var(--mz-ip-bg, #0f1216); color: var(--mz-ip-fg, #e7e7e7);
  border: 1px solid var(--mz-ip-bd, #2b2f36); border-radius: 8px; padding: 6px 8px;
}
.mz-im-row button {
  padding: 6px 10px; border-radius: 8px; border: 1px solid var(--mz-bd, #2b2f36);
  background: var(--mz-btn-bg, #1a1e24); color: var(--mz-btn-fg, #e7e7e7); cursor: pointer;
}
.mz-im-drop {
  border: 1px dashed var(--mz-drop-bd, #3b4350); border-radius: 8px;
  padding: 10px; text-align: center; font-size: 12px; margin-bottom: 8px;
  background: var(--mz-drop-bg, #0e1116);
}
.mz-im-drop.on { background: var(--mz-drop-on, #172033); }
.mz-im-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(92px, 1fr));
  gap: 8px; max-height: 320px; overflow: auto; padding: 2px;
}
.mz-im-card { border: 1px solid var(--mz-card-bd, #2b2f36); border-radius: 8px; overflow: hidden;
  background: var(--mz-card-bg, #12151a); display: flex; flex-direction: column; }
.mz-im-card img { width: 100%; height: 82px; object-fit: cover; display: block; }
.mz-im-actions { display: flex; gap: 6px; padding: 6px; justify-content: space-between; }
.mz-im-actions button {
  flex: 1; padding: 4px 6px; border-radius: 6px; border: 1px solid var(--mz-bd, #2b2f36);
  background: var(--mz-btn2-bg, #1b2027); color: var(--mz-btn2-fg, #e7e7e7); cursor: pointer; font-size: 12px;
}
`;
export {
  A as imageManagerPlugin,
  U as imageManagerStyles
};
//# sourceMappingURL=imageManagerPlugin.js.map
